import { useEffect, useState } from 'react'

/**
 * Delays rendering children by a specified duration.
 * Prevents flash of loading content.
 */
export const Delayed = ({
  children,
  delayMs = 500,
}: React.PropsWithChildren<{ delayMs?: number }>) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delayMs)
    return () => clearTimeout(timer)
  }, [delayMs])

  if (!show) return null
  return <>{children}</>
}
